// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 11007-手环机发放记录查询 分页查询手环机发放记录 POST /web/v1/braceletMachine/action/list */
export async function actionList(
  body: API.BraceletMachineActionListReqVO,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOYmPageResVOSwimGymBraceletMachineActionListVo>(
    "/web/v1/braceletMachine/action/list",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 11003-手环机新增 新增手环机 POST /web/v1/braceletMachine/add */
export async function add(
  body: API.BraceletMachineAddReqVO,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOLong>("/web/v1/braceletMachine/add", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 11005-手环机删除 根据ID删除手环机 GET /web/v1/braceletMachine/delete/${param0} */
export async function deleteUsingGet(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteUsingGETParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOBoolean>(
    `/web/v1/braceletMachine/delete/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 11002-手环机详情查询 根据ID查询手环机详情 GET /web/v1/braceletMachine/detail/${param0} */
export async function detail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.detailParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimGymBraceletMachineDetailVo>(
    `/web/v1/braceletMachine/detail/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 11001-手环机列表查询 查询手环机列表，支持按场馆ID过滤 GET /web/v1/braceletMachine/list */
export async function list(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.listParams,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOListSwimGymBraceletMachineListVo>(
    "/web/v1/braceletMachine/list",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 11004-手环机修改 修改手环机信息 POST /web/v1/braceletMachine/update */
export async function update(
  body: API.BraceletMachineUpdateReqVO,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/braceletMachine/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 11006-手环机状态变更 更新手环机状态 POST /web/v1/braceletMachine/updateStatus */
export async function updateStatus(
  body: API.BraceletMachineStatusUpdateReqVO,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>(
    "/web/v1/braceletMachine/updateStatus",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}
